export const SIGN_IN_TYPE = 'auth/SIGN_IN_TYPE';
export const SET_USER_INFO_TYPE = 'auth/SET_USER_INFO_TYPE';
export const SET_USER_CODE = 'auth/SET_USER_CODE';
export const SET_IS_AUTHENTICATED_TYPE = 'auth/SET_IS_AUTHENTICATED_TYPE';
export const RESET_STORE_TYPE = 'auth/RESET_STORE_TYPE';
export const SIGN_UP = 'auth/SIGN_UP';
export const SET_IS_AUTHENTICATED = 'auth/SET_IS_AUTHENTICATED';
export const SIGN_OUT = 'auth/SIGN_OUT';
export const VERIFICATION_CODE_SIGNUP = 'auth/VERIFICATION_CODE_SIGNUP';
export const RESEND_VERIFICATION_CODE_SIGNUP = 'auth/RESEND_VERIFICATION_CODE_SIGNUP';
export const CODE_CONFIRM = 'auth/CODE_CONFIRM';
export const SET_AUTHENTICATION = 'auth/SET_AUTHENTICATION';
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const RESEND_RESET_PASSWORD_CODE = 'auth/RESEND_RESET_PASSWORD_CODE';
export const SET_USER_EMAIL = 'auth/SET_USER_EMAIL';
export const RESET_STORE = 'auth/RESET_STORE';
export const UPDATE_PASSWORD = 'auth/UPDATE_PASSWORD';
export const SET_USER_COUPON = 'auth/SET_USER_COUPON';
export const SIGN_IN_SOCIAL = 'auth/SIGN_IN_SOCIAL';
export const SIGN_UP_SET_EMAIL = 'auth/SIGN_UP_SET_EMAIL';
export const CONFIRM_SIGN_UP = 'auth/CONFIRM_SIGN_UP';
export const RESEND_CONFIRMATION_CODE = 'auth/RESEND_CONFIRMATION_CODE';
export const RESEND_LINK = 'auth/RESEND_LINK';
